// Ce fichier est charge uniquement sur les pages collection (voir
// layout/theme.liquid : {% if template contains 'collection' %}), pour ne
// pas faire telecharger/analyser ce code sur les pages produit, l'accueil,
// le panier, etc. ou il ne sert a rien.

(function () {
  // Sur la collection "Cartes gradees", si elle est vide, on remplace le
  // message generique de Shopify ("Ca arrive bientot... utilisez moins de
  // filtres") par un message clair expliquant qu'il n'y a pas encore de
  // cartes gradees en stock, avec des liens vers d'autres collections.
  if (window.location.pathname.indexOf('/collections/cartes-gradees') !== 0) return;

  function personnaliserMessageVide() {
    var vide = document.querySelector('.main-collection-grid__empty');
    if (!vide || vide.dataset.nemeePersonnalise) return;
    vide.dataset.nemeePersonnalise = '1';

    var titre = vide.querySelector('.main-collection-grid__empty-title');
    if (titre) titre.textContent = 'Pas encore de cartes gradées en stock';

    var texte = vide.querySelector('p');
    if (texte) {
      texte.innerHTML = 'Cette collection arrive très prochainement ! En attendant, découvrez nos <a href="/collections/cartes-a-lunite">cartes à l\'unité</a> ou notre <a href="/collections/pokemon">catalogue complet</a>.';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', personnaliserMessageVide);
  } else {
    personnaliserMessageVide();
  }

  var cibleObservation = document.querySelector('collection-component') || document.body;
  var observateurVide = new MutationObserver(personnaliserMessageVide);
  observateurVide.observe(cibleObservation, { childList: true, subtree: true });
})();

(function () {
  // Sur les collections de cartes a l'unite (et cartes gradees), on affiche
  // directement sur chaque vignette de produit un court rappel de l'etat
  // (Mint), de la protection (pochette + toploader) et du delai
  // d'expedition (48h), pour eviter aux visiteurs de devoir ouvrir chaque
  // fiche produit pour comparer plusieurs cartes (cf. rapport SimGym).
  // On ne touche pas aux collections de produits scelles (displays,
  // boosters...) qui ont une garantie differente.
  var COLLECTIONS_CARTES_UNITE = [
    '/collections/cartes-a-lunite',
    '/collections/cartes-a-lunite-ar',
    '/collections/cartes-a-lunite-sar',
    '/collections/cartes-a-lunite-holographique',
    '/collections/cartes-gradees'
  ];

  var chemin = window.location.pathname.replace(/\/$/, '');
  var estCollectionConcernee = COLLECTIONS_CARTES_UNITE.some(function (c) {
    return chemin === c || chemin.indexOf(c + '/') === 0;
  });
  if (!estCollectionConcernee) return;

  function ajouterBadges() {
    var cartes = document.querySelectorAll('product-card.product-card');
    cartes.forEach(function (carte) {
      if (carte.dataset.nemeeBadge) return;
      var contenu = carte.querySelector('.product-card__content');
      if (!contenu) return;
      carte.dataset.nemeeBadge = '1';

      var badge = document.createElement('div');
      badge.className = 'nemee-carte-badge';
      badge.innerHTML =
        '<span>Mint</span><span aria-hidden="true">·</span>' +
        '<span>Pochette + toploader</span><span aria-hidden="true">·</span>' +
        '<span>Exp. 48h</span>';
      contenu.appendChild(badge);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ajouterBadges);
  } else {
    ajouterBadges();
  }

  var cibleObservation = document.querySelector('collection-component') || document.body;
  var observateurBadges = new MutationObserver(ajouterBadges);
  observateurBadges.observe(cibleObservation, { childList: true, subtree: true });
})();
